import Colors, { withOpacity } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const PauseButtonTheme = {
    pauseButton: {
        light: {
            states: {
                enabled: {
                    color: Colors.black,
                },
                disabled: {
                    color: withOpacity(Colors.black, Opacities.low),
                },
                hover: {
                    color: withOpacity(Colors.black, Opacities.medium),
                },
                active: {
                    color: Colors.black,
                },
            },
        },
        dark: {
            states: {
                enabled: {
                    color: Colors.white,
                },
                disabled: {
                    color: withOpacity(Colors.white, Opacities.low),
                },
                hover: {
                    color: withOpacity(Colors.white, Opacities.medium),
                },
                active: {
                    color: Colors.white,
                },
            },
        },
    },
};
export default PauseButtonTheme;
